import { DeviceOS, DeviceType, OnelinkType } from './types';

export const ONELINK_URL_PATH_BY_DEVICE: OnelinkType = {
  android: {
    mobile: 'https://lemanapro.onelink.me/lj2G/bw5obr6f',
    desktop: 'https://lemanapro.onelink.me/lj2G/bw5obr6f',
  },
  os: {
    mobile: 'https://lemanapro.onelink.me/lj2G/vu2b3nlk',
    desktop: 'https://lemanapro.onelink.me/lj2G/vu2b3nlk',
  },
  huawei: {
    mobile: 'https://lemanapro.onelink.me/lj2G/ojqyxtce',
    desktop: 'https://lemanapro.onelink.me/lj2G/ojqyxtce',
  },
};

const UTM_LABELS_MAP: Record<string, string> = {
  utm_source: 'pid',
  utm_medium: 'af_channel',
  utm_campaign: 'c',
  utm_term: 'af_adset',
  utm_content: 'af_ad',
};

export const createOpenlinkUrl = (os: DeviceOS, src: DeviceType, utmLabels: string[][] = [[]]) => {
  const searchParams =
    utmLabels.length && utmLabels[0].length
      ? utmLabels.reduce((result, [key, value]) => {
          result.append(UTM_LABELS_MAP[key], value);
          return result;
        }, new URLSearchParams())
      : undefined;
  return `${ONELINK_URL_PATH_BY_DEVICE[os][src]}${searchParams ? `?${searchParams.toString()}` : ''}`;
};

export const filterSearchParamsByUtm = (params: string[][]) =>
  params.filter(([key]) => Object.keys(UTM_LABELS_MAP).includes(key));
